'use strict';

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var CID = require('cids');

var util = require('./util');
/**
 * Resolves a path within a PB block.
 *
 * Returns the value or a link and the partial mising path. This way the
 * IPLD Resolver can fetch the link and continue to resolve.
 *
 * @param {Buffer} binaryBlob - Binary representation of a PB block
 * @param {string} [path='/'] - Path that should be resolved
 * @returns {Object} result - Result of the path it it was resolved successfully
 * @returns {*} result.value - Value the path resolves to
 * @returns {string} result.remainderPath - If the path resolves half-way to a
 *   link, then the `remainderPath` is the part after the link that can be used
 *   for further resolving
 */


exports.resolve = function (binaryBlob, path) {
  var node = util.deserialize(binaryBlob);
  var parts = path.split('/').filter(Boolean);

  while (parts.length) {
    var key = parts.shift();

    if (node[key] === undefined) {
      throw new Error("Object has no property '".concat(key, "'"));
    }

    node = node[key];

    if (CID.isCID(node)) {
      return {
        value: node,
        remainderPath: parts.join('/')
      };
    }
  }

  return {
    value: node,
    remainderPath: ''
  };
};

var traverse = /*#__PURE__*/_regeneratorRuntime.mark(function traverse(node, path) {
  var _i, _Object$keys, item, nextpath;

  return _regeneratorRuntime.wrap(function traverse$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(Buffer.isBuffer(node) || CID.isCID(node) || typeof node === 'string' || node === null)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return");

        case 2:
          _i = 0, _Object$keys = Object.keys(node);

        case 3:
          if (!(_i < _Object$keys.length)) {
            _context.next = 12;
            break;
          }

          item = _Object$keys[_i];
          nextpath = path === undefined ? item : path + '/' + item;
          _context.next = 8;
          return nextpath;

        case 8:
          return _context.delegateYield(traverse(node[item], nextpath), "t0", 9);

        case 9:
          _i++;
          _context.next = 3;
          break;

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, traverse);
});
/**
 * Return all available paths of a block.
 *
 * @generator
 * @param {Buffer} binaryBlob - Binary representation of a PB block
 * @yields {string} - A single path
 */


exports.tree = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binaryBlob) {
  var node;
  return _regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          node = util.deserialize(binaryBlob);
          return _context2.delegateYield(traverse(node), "t0", 2);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee);
});